import { NativeBridgeResponse } from 'scbk-services/types/bridge/global';
import { create } from 'zustand';

export type NativeBridgeCallbackFn<T> = (payload: T) => void | Promise<void>;

export type NativeBridgeCallbackInf<T> = {
    once?: boolean;
    fn: NativeBridgeCallbackFn<T>;
};
/**
 *
 */
export interface NativeBridgeCallbackRegistryState {
    /**
     * 네이티브 브릿지 callback store
     */
    callbacks: Record<string, NativeBridgeCallbackInf<any>>;

    /**
     * 콜백함수를 등록한다.
     * @param callbacKId 콜백ID
     * @param fn 콜백함수
     * @returns
     */
    registerCallback: <T>(callbacKId: string, inf: NativeBridgeCallbackInf<T>) => void;

    /**
     * 콜백함수 제거
     * @param callbacKId 콜백ID
     * @returns
     */
    unregisterCallback: (callbacKId: string) => void;

    /**
     * 등록된 콜백함수를 찾아 함수를 실행한다.
     * @param callbackId 콜백ID
     * @param payload 네이티브 응답 객체
     * @returns
     */
    invokeCallback: (callbackId: string, payload: NativeBridgeResponse<unknown>) => void;

    /**
     * 콜백ID로 등록된 콜백함수가 있는지 확인
     * @param callbackId 콜백ID
     * @returns 콜백ID로 등록된 콜백함수가 있는지 여부
     */
    hasCallback: (callbackId: string) => boolean;

    /**
     * store 클리어
     * @returns
     */
    clear: () => void;
}

/**
 * 네이티브 브릿지 콜백함수 store
 */
const useNativeBridgeCallbackRegistryStore = create<NativeBridgeCallbackRegistryState>()(
    (set, get) => ({
        callbacks: {},
        registerCallback: <T>(callbacKId: string, inf: NativeBridgeCallbackInf<T>) => {
            set((state) => ({
                callbacks: {
                    ...state.callbacks,
                    [callbacKId]: inf,
                },
            }));
        },
        unregisterCallback: (callbacKId: string) => {
            set((state) => {
                const { [callbacKId]: _removed, ...rest } = state.callbacks;
                return {
                    callbacks: rest,
                };
            });
        },
        invokeCallback: (callbackId: string, payload: NativeBridgeResponse<unknown>) => {
            console.log('#invokeCallback callbacKId', callbackId);
            const callbackInf = get().callbacks[callbackId];
            if (!callbackInf) {
                return;
            }

            console.log('#invokeCallback callbackInf', callbackInf);

            const { fn, once } = callbackInf;
            if (!fn) {
                return;
            }
            void fn(payload);

            if (once) {
                get().unregisterCallback(callbackId);
            }
        },

        hasCallback: (callbackId: string): boolean => {
            return !!get().callbacks[callbackId];
        },
        clear: () => {
            set({ callbacks: {} });
        },
    }),
);

export { useNativeBridgeCallbackRegistryStore };
